// extracted by mini-css-extract-plugin
export default {"clickableBitstray":"StandaloneBitstray_clickableBitstray__11IuD"};